/* HOT PUP — interactividad de las secciones propias */
(function () {
  'use strict';
  if (window.__hpInit) return;
  window.__hpInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un único observer) ---------- */
  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.hp-reveal:not(.hp-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('hp-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hp-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
    initRevealRespaldo();
  }

  /* Respaldo: si se hace scroll muy rápido, revela lo que ya ha quedado por encima */
  var respaldoListo = false;
  function initRevealRespaldo() {
    if (respaldoListo) return;
    respaldoListo = true;
    var pendiente = false;
    var revisar = function () {
      pendiente = false;
      var limite = window.innerHeight;
      document.querySelectorAll('.hp-reveal:not(.hp-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limite) {
          el.classList.add('hp-visible');
          if (observer) observer.unobserve(el);
        }
      });
    };
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; setTimeout(revisar, 150); }
    }, { passive: true });
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparadores(root) {
    (root || document).querySelectorAll('[data-hp-comparador]').forEach(function (caja) {
      if (caja.dataset.hpListo) return;
      caja.dataset.hpListo = '1';
      var rango = caja.querySelector('.hp-comparador__rango');
      if (!rango) return;
      var actualizar = function () { caja.style.setProperty('--hp-pos', rango.value + '%'); };
      rango.addEventListener('input', actualizar);
      actualizar();
    });
  }

  /* ---------- Contador animado ---------- */
  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-hp-contar]');
    if (!els.length) return;
    var animar = function (el) {
      var fin = parseFloat(el.dataset.hpContar) || 0;
      if (reduceMotion) { el.textContent = fin; return; }
      var inicio = null;
      var paso = function (t) {
        if (!inicio) inicio = t;
        var p = Math.min((t - inicio) / 1400, 1);
        el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(paso);
      };
      requestAnimationFrame(paso);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animar(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Producto: galería deslizable ---------- */
  function initGalerias(root) {
    (root || document).querySelectorAll('[data-hp-galeria]').forEach(function (gal) {
      if (gal.dataset.hpListo) return;
      gal.dataset.hpListo = '1';
      var pista = gal.querySelector('[data-hp-pista]');
      if (!pista) return;
      var slides = pista.children;
      var actual = gal.querySelector('[data-hp-actual]');
      var marcadores = gal.querySelectorAll('[data-hp-ir]');
      var indice = 0;

      var marcar = function (i) {
        indice = i;
        if (actual) actual.textContent = i + 1;
        marcadores.forEach(function (m) { m.classList.toggle('is-activo', parseInt(m.dataset.hpIr, 10) === i); });
      };
      var ir = function (i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        pista.scrollTo({ left: slides[i].offsetLeft - pista.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        marcar(i);
      };
      var pendiente = false;
      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var i = Math.round(pista.scrollLeft / (pista.clientWidth || 1));
          if (i !== indice) marcar(i);
        });
      }, { passive: true });
      marcadores.forEach(function (m) {
        m.addEventListener('click', function () { ir(parseInt(m.dataset.hpIr, 10)); });
      });
      gal.querySelectorAll('[data-hp-flecha]').forEach(function (b) {
        b.addEventListener('click', function () {
          var siguiente = indice + parseInt(b.dataset.hpFlecha, 10);
          if (siguiente < 0) siguiente = slides.length - 1;
          if (siguiente >= slides.length) siguiente = 0;
          ir(siguiente);
        });
      });
      /* Arrastrar con el ratón (ordenador y vista móvil del editor). En el móvil real el dedo ya desliza solo. */
      var arrastre = null;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        arrastre = { x: e.clientX, scroll: pista.scrollLeft, movido: false };
        pista.classList.add('is-arrastrando');
        pista.setPointerCapture(e.pointerId);
      });
      pista.addEventListener('pointermove', function (e) {
        if (!arrastre) return;
        var dx = e.clientX - arrastre.x;
        if (Math.abs(dx) > 4) arrastre.movido = true;
        pista.scrollLeft = arrastre.scroll - dx;
      });
      var soltar = function (e) {
        if (!arrastre) return;
        var dx = e.clientX - arrastre.x;
        var ancho = pista.clientWidth || 1;
        var base = Math.round(arrastre.scroll / ancho);
        var destino = base;
        if (dx < -ancho * 0.15) destino = base + 1;
        if (dx > ancho * 0.15) destino = base - 1;
        var movido = arrastre.movido;
        arrastre = null;
        pista.classList.remove('is-arrastrando');
        ir(destino);
        if (movido) {
          var bloquear = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          pista.addEventListener('click', bloquear, { capture: true, once: true });
          setTimeout(function () { pista.removeEventListener('click', bloquear, { capture: true }); }, 50);
        }
      };
      pista.addEventListener('pointerup', soltar);
      pista.addEventListener('pointercancel', soltar);
      pista.addEventListener('dragstart', function (e) { e.preventDefault(); });

      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { ir(indice + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { ir(indice - 1); e.preventDefault(); }
      });
    });
  }

  /* ---------- Producto: packs, tallas por unidad y carrito ---------- */
  function formatearDinero(cents, formato) {
    var valor = (cents / 100).toFixed(2);
    var conComa = valor.replace('.', ',');
    var sinDecimales = Math.round(cents / 100).toString();
    var f = formato || '{{amount_with_comma_separator}} €';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      if (tipo === 'amount_with_comma_separator') return conComa;
      if (tipo === 'amount_no_decimals' || tipo === 'amount_no_decimals_with_comma_separator') return sinDecimales;
      return valor;
    });
  }

  function initProductos(root) {
    (root || document).querySelectorAll('[data-hp-producto]').forEach(function (prod) {
      if (prod.dataset.hpListo) return;
      prod.dataset.hpListo = '1';

      var seccion = prod.closest('.hp-pdp') || prod;
      var datosEl = prod.querySelector('[data-hp-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var formato = prod.dataset.moneyFormat;
      var form = prod.querySelector('form');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var inputCantidad = form ? form.querySelector('[data-hp-cantidad]') : null;
      var boton = prod.querySelector('[data-hp-comprar]');
      var textoBoton = boton ? boton.querySelector('[data-hp-boton-texto]') : null;
      var error = prod.querySelector('[data-hp-error]');
      var packs = prod.querySelectorAll('[data-hp-pack]');
      var barra = seccion.querySelector('[data-hp-barra]');
      var barraPrecio = barra ? barra.querySelector('[data-hp-barra-precio]') : null;

      var packActivo = function () {
        return prod.querySelector('[data-hp-pack].is-activo') || packs[0];
      };

      var varianteDeUnidad = function (unidad) {
        var valores = [];
        unidad.querySelectorAll('[data-hp-opcion]').forEach(function (campo) {
          valores[parseInt(campo.dataset.hpOpcion, 10)] = campo.value;
        });
        return variantes.find(function (v) {
          return v.options.every(function (op, i) { return valores[i] === undefined || op === valores[i]; });
        });
      };

      var lineasDelPack = function (pack) {
        var cantidad = parseInt(pack.dataset.cantidad, 10) || 1;
        var unidades = pack.querySelectorAll('[data-hp-unidad]');
        var lineas = [];
        if (!unidades.length) {
          var v0 = variantes.find(function (v) { return v.available; }) || variantes[0];
          for (var i = 0; i < cantidad; i++) lineas.push(v0);
          return lineas;
        }
        unidades.forEach(function (u) { lineas.push(varianteDeUnidad(u)); });
        return lineas;
      };

      var actualizar = function () {
        var pack = packActivo();
        if (!pack) return;
        var lineas = lineasDelPack(pack);
        var completas = lineas.every(function (v) { return v; });
        var disponibles = completas && lineas.every(function (v) { return v.available; });
        var descuento = parseFloat(pack.dataset.descuento) || 0;
        var bruto = 0;
        var rebaja = 0;
        if (completas) {
          /* Igual que Shopify: el descuento se calcula por línea (misma talla = misma línea) y se redondea hacia abajo */
          var porLinea = {};
          lineas.forEach(function (v) { bruto += v.price; porLinea[v.id] = (porLinea[v.id] || 0) + v.price; });
          Object.keys(porLinea).forEach(function (id) { rebaja += Math.floor(porLinea[id] * descuento / 100); });
        }
        var total = bruto - rebaja;

        var precioEl = pack.querySelector('[data-hp-pack-precio]');
        var antesEl = pack.querySelector('[data-hp-pack-antes]');
        var ahorroEl = pack.querySelector('[data-hp-pack-ahorro]');
        if (completas && precioEl) precioEl.textContent = formatearDinero(total, formato);
        if (completas && antesEl) antesEl.textContent = formatearDinero(bruto, formato);
        if (completas && ahorroEl) ahorroEl.textContent = formatearDinero(bruto - total, formato);
        if (barraPrecio && completas) barraPrecio.textContent = formatearDinero(total, formato);

        if (inputId && lineas[0]) inputId.value = lineas[0].id;
        if (inputCantidad) inputCantidad.value = lineas.length;
        if (boton) {
          boton.disabled = !disponibles;
          if (textoBoton) textoBoton.textContent = disponibles ? prod.dataset.textoComprar : prod.dataset.textoAgotado;
        }
      };

      packs.forEach(function (pack) {
        var radio = pack.querySelector('input[type="radio"]');
        var activar = function () {
          packs.forEach(function (p) { p.classList.toggle('is-activo', p === pack); });
          if (radio) radio.checked = true;
          actualizar();
        };
        if (radio) radio.addEventListener('change', activar);
        pack.addEventListener('click', function (e) {
          if (e.target.closest('select')) { if (!pack.classList.contains('is-activo')) activar(); return; }
          if (!pack.classList.contains('is-activo')) activar();
        });
        pack.querySelectorAll('select').forEach(function (s) { s.addEventListener('change', actualizar); });
      });

      /* Añadir al carrito con todas las unidades del pack y abrir el carrito lateral */
      var abrirCarrito = function (respuesta) {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && respuesta.sections) {
          try {
            drawer.renderContents(respuesta);
            var burbuja = document.getElementById('cart-icon-bubble');
            if (burbuja && respuesta.sections['cart-icon-bubble']) {
              var doc = new DOMParser().parseFromString(respuesta.sections['cart-icon-bubble'], 'text/html');
              var nuevo = doc.querySelector('.shopify-section');
              if (nuevo) burbuja.innerHTML = nuevo.innerHTML;
            }
            return;
          } catch (err) { /* si falla, vamos a la página del carrito */ }
        }
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      };

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var pack = packActivo();
          var lineas = lineasDelPack(pack);
          if (!lineas.every(function (v) { return v && v.available; })) return;
          var porId = {};
          var orden = [];
          lineas.forEach(function (v) {
            if (!porId[v.id]) { porId[v.id] = 0; orden.push(v.id); }
            porId[v.id] += 1;
          });
          var items = orden.map(function (id) { return { id: id, quantity: porId[id] }; });
          if (error) error.textContent = '';
          if (boton) boton.classList.add('is-cargando');
          fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
          })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok || res.j.status) {
                if (error) error.textContent = res.j.description || res.j.message || 'No se pudo añadir. Inténtalo de nuevo.';
                return;
              }
              abrirCarrito(res.j);
            })
            .catch(function () { form.submit(); })
            .finally(function () { if (boton) boton.classList.remove('is-cargando'); });
        });
      }

      /* Barra fija: aparece cuando el botón principal sale de pantalla */
      if (barra && boton && 'IntersectionObserver' in window) {
        var botonBarra = barra.querySelector('[data-hp-barra-boton]');
        var visibleBoton = true;
        var visibleFinal = false;
        var refrescar = function () { barra.classList.toggle('is-visible', !visibleBoton && !visibleFinal); };
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            visibleBoton = en.isIntersecting || en.boundingClientRect.top > window.innerHeight;
            refrescar();
          });
        }).observe(boton);
        var pie = document.querySelector('.hp-footer, footer');
        if (pie) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { visibleFinal = en.isIntersecting; refrescar(); });
          }).observe(pie);
        }
        if (botonBarra) {
          botonBarra.addEventListener('click', function () {
            var destino = prod.querySelector('.hp-packs') || boton;
            destino.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          });
        }
      }

      actualizar();
    });
  }

  /* Enlaces "#hp-comprar" de otras secciones: llevan a los packs */
  function initAnclas() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#hp-comprar"]');
      if (!a) return;
      var destino = document.querySelector('.hp-packs') || document.getElementById('hp-comprar');
      if (!destino) return;
      e.preventDefault();
      destino.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function initTodo(root) {
    initReveals(root);
    initComparadores(root);
    initContadores(root);
    initGalerias(root);
    initProductos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); initAnclas(); });
  } else {
    initTodo(document);
    initAnclas();
  }

  /* Editor de Shopify: re-inicializar al añadir o editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
